import { makeUseFetchOne } from '@elentari/core'
import { estadosRepository } from './estadosRepository'
import { EstadosDetail } from '../types'

export const useEstado = makeUseFetchOne<EstadosDetail, string>({
  fetch: estadosRepository.fetchOne
})
